"use client";
import React from "react";
import { TableOfContentsCard } from "@ui/TableOfContents";
import { Slice } from "gatsby";

export type BlogPostAsideRef = {
  setActiveSection: (value: string) => void;
  setSection: (value: string[]) => void;
};

type BlogAuthor = {
  AuthorName: string | null;
  AuthorJobTitle: string | null;
  AuthorFacebook: string | null;
  AuthorTwitter: string | null;
  AuthorLinkedIn: string | null;
  AuthorDescription: string | null;
  AuthorBio: {
    data: { AuthorBio: string | null } | null;
  } | null;
  AuthorImage: {
    localFile: {
      childImageSharp: {
        gatsbyImageData: import("gatsby-plugin-image").IGatsbyImageData;
      } | null;
    } | null;
  } | null;
};

const BlogPostAside = ({
  blogAuthor,
  contentsLabel,
  // shareArticleLabel,
  sections,
}: {
  blogAuthor: BlogAuthor | null;
  contentsLabel: string;
  shareArticleLabel: string;
  sections: string[];
}) => {
  return (
    <div className="relative top-[-90px] h-full md:w-80">
      {sections?.length > 0 && blogAuthor?.AuthorImage && (
        <TableOfContentsCard
          contents={[...sections].reverse().map(section => ({
            sectionName: section,
          }))}
          contentsLabel={contentsLabel}
        />
      )}
      <div className="sticky top-[120px] mt-6">
        <Slice alias="floatingad" allowEmpty />
      </div>
    </div>
  );
};

export default BlogPostAside;
